import React, { useState, useEffect } from "react"
import PJMFooterLogo from "../svg/PJMFooterLogo"
import Arrow from "../svg/arrows/Index"
import colors from "../theme_colors"
import SliderNav from "../slider_nav/slider_nav"
import ContextConsumer from "../context"
import { useStaticQuery, graphql } from "gatsby"
import TransitionLink from "gatsby-plugin-transition-link"
import { FiArrowRight, FiArrowUp, FiDownload } from "react-icons/fi"
// import PDF1 from "../../images/PJM_2019_Financials_Individual.pdf"
// import PDF2 from "../../images/PJM_2019_Financials_Individual.pdf"

const PageFooter = ({
  slideView,
  slideIndex,
  appWidth,
  navShow,
  setPath,
  set,
  toggleView,
  appHeight,
}) => {
  // console.log(appWidth, appHeight, 'foot')
  const [stateIndex, setStateIndex] = useState(slideIndex);
  const [rightPage, setRightPage] = useState({
    id: 0,
    path: '/welcome',
    correct: false,
  })
  
  if (slideIndex !== stateIndex) {
    setStateIndex(slideIndex)
  }

  useEffect(() => {
    setPath(window.location.pathname);
  }, [])

  useEffect(() => {
    setStateIndex(slideIndex);
  },[slideView])

  useEffect(() => {  
    let currentPath = window.location.pathname;
    let menuLinks = data.site.siteMetadata.menuLinks;
    for(let x = 0; x < menuLinks.length; x++) {
      if(menuLinks[x].link === currentPath && currentPath !== "/welcome") {
        const newRightPage = {
          id: menuLinks[x].id,
          path: menuLinks[x].link,
          correct: false,
        }
        setRightPage(newRightPage);
        set({slideIndex: menuLinks[x].id, path: menuLinks[x].link});
      }
    }
    // console.log(rightPage);
  }, [rightPage.id])

  useEffect(() => {
    if(stateIndex === 0 && slideView) {
      document.querySelector('.prevControl').style.display = "none";
    } else if(slideView) {
      document.querySelector('.prevControl').style.display = "";
    }
  }, [stateIndex, slideView])

  const data = useStaticQuery(graphql`
    query menuLinksQuery {
      site {
        siteMetadata {
          menuLinks {
            name
            name2
            link
            id
            color
          }
        }
      }
    }
  `)
  const currentIndex = slideIndex
  const nextSlideIndex = currentIndex + 1 == 10 ? 9 : currentIndex + 1 
  const prevSlideIndex = currentIndex - 1 <= -1 ? 0 : currentIndex - 1 
  const nameSlugPrev = data.site.siteMetadata.menuLinks[prevSlideIndex].link
  const nameSlugNext = data.site.siteMetadata.menuLinks[nextSlideIndex].link
  const namePrev = data.site.siteMetadata.menuLinks[prevSlideIndex].name2
  const nameNext = data.site.siteMetadata.menuLinks[nextSlideIndex].name2
  const nextColor = nextSlideIndex === 5 ? "green" : data.site.siteMetadata.menuLinks[nextSlideIndex].color.split("|")[0] || "green";
  const prevColor = prevSlideIndex === 5 ? "green" : data.site.siteMetadata.menuLinks[prevSlideIndex].color.split("|")[0] || "green";

  function scrollToTop() {
    window.scrollTo(0,0);
  }

  if (slideView) {
    return (
      <div className="foot">
        <div className={currentIndex === 9 ? "footer-page-controls final-page" : "footer-page-controls"}>
          <div className="nav-controls">
            <TransitionLink
              onClick={() => {
                set({ slideIndex: prevSlideIndex, path: `${nameSlugPrev}` });
                setStateIndex(prevSlideIndex);
              }}
              to={`${nameSlugPrev}`}
              className="footer-control prevControl"
            >
              <div className={"prevArrow " + prevColor}>
                <FiArrowRight />
              </div>
              <p>
                Prev:&nbsp;<span className="">{(currentIndex < 10 ? "0" + (prevSlideIndex + 1) : (prevSlideIndex + 1)) + " " + namePrev}</span>
              </p>
            </TransitionLink>
            <TransitionLink
              onClick={() => {
                set({ slideIndex: nextSlideIndex, path: `${nameSlugNext}` });
                setStateIndex(nextSlideIndex);
              }}
              to={`${nameSlugNext}`}
              className="footer-control nextControl"
            >
              <p>
                Next:&nbsp;<span className="">{(currentIndex < 8 ? "0" + (nextSlideIndex + 1) : (nextSlideIndex + 1)) + " " + nameNext}</span>
              </p>
              <div className={"nextArrow " + nextColor}>
                <FiArrowRight />
              </div>
            </TransitionLink>
          </div>
          
          <a
            target="_blank"
            href="https://www.pjm.com/-/media/about-pjm/newsroom/annual-reports/2019-annual-report.ashx"
            className="download-link footer-control"
          >
            <p>EDITORIAL REPORT</p>
            <div className="downloadArrow">
              <FiDownload />
            </div>
          </a>
          <a 
            target="_blank"
            href='https://pjm.com/~/media/about-pjm/newsroom/annual-reports/2019-financials.ashx'
            className="download-link footer-control"
          >
            <p>FINANCIAL REPORT</p>
            <div className="downloadArrow">
              <FiDownload />
            </div>
          </a>

          <div 
            className="top-control footer-control"
            onClick={scrollToTop}
          >
            <p>Back to Top</p>
            <div className="upArrow">
              <FiArrowUp />
            </div>
          </div>
        </div>
        <div>
          <footer id="inner-page-footer">
            <div className="footer-logo-container">
              <div className="footer-logo-svg-container">
                <PJMFooterLogo />
              </div>
              <p className="footer-logo-text">
                Working to Perfect the Flow of Energy
              </p>
            </div>
            <div className="footer-copy-container">
              <p>
                <span>&ensp;For information, please contact:&ensp;</span><span className="m-b">866.400.8980&ensp;&bull;&ensp;www.pjm.com</span><br />
                <span>“PJM” is a registered trademark of PJM Interconnection, L.L.C.</span><br />
                <span>PJM ©2020 All rights reserved</span>
              </p>
            </div>
          </footer>
        </div>
      </div>
    )
  } else if (navShow) {
    return <SliderNav toggleView={toggleView} appWidth={appWidth} appHeight={appHeight} slideIndex={slideIndex} />
  } else {
    return null
  }
}
export default PageFooter
